import React, { Component } from 'react';
import moment from 'moment';

import store from '@tvguide/store';

import Program from './program';

const getHighligh = (programGenre, highlights) => {
  return highlights.find(el => el.mdsGenre === programGenre);
};

class ProgramsList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const currentTime = moment();

    const highlights = this.props.highlights.length
      ? this.props.highlights
      : store.getState().ux.highlights;

    return (
      <ul>
        {this.props.programs.map(p => (
          <Program
            key={`grid-${p.uuid}`}
            p={p}
            sid={this.props.sid}
            currentTime={currentTime}
            pixelRatio={this.props.minutesPixelRatio}
            handleClick={this.props.displayProgramDetails.bind(this)}
            isActive={this.props.detailPanelProgramId == p.uuid}
            leftOffset={moment
              .utc(p.start_time)
              .add(+this.props.isDST, 'hour')
              .diff(moment.utc(this.props.beginDate), 'minutes')}
            isDST={this.props.isDST}
            accessibility={this.props.accessibility}
            highlight={getHighligh(p.genre, highlights)}
          />
        ))}
      </ul>
    );
  }
}

export default ProgramsList;
